app.directive('programDetailScrollContainer', function ($window, throttle, $log) {
    return {
        restrict: 'A',
        link: function ($scope, $element, $attrs) {
            var scrollToProperRequest = function () {
                var openToCard = 0;

                if ($scope.programDetail.openToCard !== 0) {
                    openToCard = $scope.programDetail.openToCard;
                    $scope.programDetail.openToCard = 0;
                }

                setTimeout(function () {
                    var elementToScroll = null;

                    if (openToCard !== 0) {
                        elementToScroll = $element.find('.sg-item-tile-container').get(openToCard);
                    }

                    if (elementToScroll) {
                        elementToScroll.scrollIntoView(true);
                    } else {
                        $element.scrollTop(0);
                        $element.scrollLeft(0);
                    }
                }, 0);
            };

            $scope.$watch('[programDetail.slick.currentIndex, programDetail.isFullscreen]', function (newValue) {
                scrollToProperRequest();
            }, true);
        }
    };
});